import C from '../pages/common/constantes'
import auth from '../services/auth'
import {cents} from '../filters/number'

function recargaValida(val, args){
  let mult = args[0];
  if(!val)
    return false;
  val = val.toString().replace(/[^0-9]/g, '');
  if(val / mult > 0 && val % mult == 0)
    return true;

  return false;
}


export default {
  messages: {
    en: (field, args) => {
      let mult = args[0];
      return `Valor de recarga inválido, valor deve ser múltiplo de ${cents(mult)}`;
    },
    'pt-BR': (field, args) => {
      let mult = args[0];
      return `Valor de recarga inválido, valor deve ser múltiplo de ${cents(mult)}`;
    }
  },
  validate(value, args) {
    return recargaValida(value, args);
  }
};

function getMult(){
  return auth.currentUser.type=='PESSOA_JURIDICA' ? C.RECHARGE_UNIT_PJ : C.RECHARGE_UNIT;
}



// WEBPACK FOOTER //
// ./src/validators/valor-recarga-valido.js